import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type {
  AlignItemsProps,
  BackgroundColorProps,
  BorderColorProps,
  BorderStyleProps,
  BorderWidthProps,
  DisplayProps,
  FlexWrapProps,
  HeightProps,
  JustifyContentProps,
  MaxWidthProps,
  OverflowProps,
  PositionProps,
  SpaceProps,
  TopProps,
  WidthProps,
  ZIndexProps,
} from 'styled-system';
import {
  alignItems,
  backgroundColor,
  borderColor,
  borderStyle,
  borderWidth,
  display,
  flexWrap,
  height,
  justifyContent,
  maxWidth,
  overflow,
  position,
  space,
  top,
  width,
  zIndex,
} from 'styled-system';

import { borderBottomWidth, borderTopWidth, boxSizing } from 'common/theme/system-utilities';
import type {
  BorderBottomWidthProps,
  BorderTopWidthProps,
  BoxSizingProps,
} from 'common/theme/system-utilities';
import {
  CONTAINER_MAX_WIDTH,
  CONTAINER_PADDING_X,
  CONTAINER_PADDING_Y,
  MINIMAL_SEARCH_CONTAINER_SIZE,
  NAV_Z_INDEX,
} from './constants';

export const Container = styled.div<
  SpaceProps &
    BorderWidthProps &
    BorderTopWidthProps &
    BorderBottomWidthProps &
    BorderColorProps &
    BorderStyleProps &
    PositionProps &
    TopProps &
    WidthProps &
    ZIndexProps &
    BackgroundColorProps &
    OverflowProps
>`
  ${space};
  ${borderWidth};
  ${borderTopWidth};
  ${borderBottomWidth};
  ${borderColor};
  ${borderStyle};
  ${position};
  ${top};
  ${width};
  ${zIndex};
  ${backgroundColor};
  ${overflow};
`;

export const containerStyles: ComponentProps<typeof Container> = {
  mx: 'auto',
  borderWidth: 0,
  borderTopWidth: 'small',
  borderBottomWidth: 'small',
  borderColor: 'sys.neutral.border.weak',
  borderStyle: 'solid',
  position: 'sticky',
  top: -1,
  width: '100%',
  zIndex: NAV_Z_INDEX,
  backgroundColor: 'sys.neutral.background.default',
  overflow: 'visible',
};

export const Grid = styled.div<
  FlexWrapProps &
    DisplayProps &
    AlignItemsProps &
    JustifyContentProps &
    MaxWidthProps &
    SpaceProps &
    BoxSizingProps &
    HeightProps
>`
  ${flexWrap};
  ${display};
  ${alignItems};
  ${justifyContent};
  ${maxWidth};
  ${space};
  ${boxSizing};
  ${height};
`;

export const gridStyles: ComponentProps<typeof Grid> = {
  flexWrap: ['wrap', 'nowrap'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  py: CONTAINER_PADDING_Y,
  px: CONTAINER_PADDING_X,
  maxWidth: CONTAINER_MAX_WIDTH,
  boxSizing: 'border-box',
  mx: 'auto',
};

export const getMinimalSearchStyles = (withAnimation: boolean, isMobile: boolean) =>
  !withAnimation && isMobile
    ? {
        minWidth: 'fit-content',
        borderRadius: 'circle',
        borderColor: 'sys.neutral.border.default',
        borderWidth: 'small',
        borderStyle: 'solid',
        size: MINIMAL_SEARCH_CONTAINER_SIZE,
      }
    : {};
